export default __webpack_public_path__ + "static/media/loading-spinner.e7205ab0.gif";